import { Modal } from '../../ds';
import styled from 'styled-components';
export const StyledModal = styled(Modal)`
  overflow: auto;
`;

export const StyledContainer = styled.div`
  width: 300px;
  @media (min-width: 768px) {
    width: 474px;
  }
  max-height: calc(100vh - 70px);
  overflow: auto;

  @media (min-width: 768px) {
    padding: 0 16px;
  }
`;

export const StyledHeader = styled.div`
  color: #000;
  font-family: DM Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  letter-spacing: 0.48px;

  @media (min-width: 768px) {
    font-size: 24px;
  }
`;

export const SyledImage = styled.div`
  padding-top: 35px;
  padding-bottom: 44px;

  img {
    width: 100%;
    height: auto;
  }
`;

export const StyledBody = styled.div`
  padding: 15px 0;
`;

export const StyledTitle = styled.div`
  color: var(--light-text-primary, #18223d);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  letter-spacing: 0.28px;
`;

export const StyleSubTitle = styled.div`
  color: var(--light-text-primary, #18223d);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  letter-spacing: 0.28px;
  padding-top: 20px;
`;

export const StyledItem = styled.li`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  letter-spacing: 0.28px;
`;

export const StyledUL = styled.ul`
  padding-left: 20px;
`;

export const StyledOL = styled.ol`
  padding: ${props => (props.hasTitle ? '0' : '10px')} 20px 10px 20px;
`;

export const StyledCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding-bottom: 30px;
`;

export const StyledContent = styled.div`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  letter-spacing: 0.28px;
`;

export const StyledLink = styled.a`
  color: #0075ff;
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  letter-spacing: 0.28px;
  display: flex;
  justify-content: flex-start;
  padding-bottom: 20px;
  cursor: pointer;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;
